// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-management-container {
  padding: 12px 16px;
  background-color: #f5f5f5;
  font-family: 'Segoe UI', sans-serif;
}

.application-management-modal .ant-modal-body{
  margin: 0px !important;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  color: var(--Black-60, #000);
  font-family: "Henkel GT Flexa";
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  /* 171.429% */
}

.search-container {
  display: flex;
  gap: 12px;
}

.search-input {
  width: 200px;
  border-radius: 8px;
  border: 1px solid var(--Gry_707070, #707070);
  background: #FFF;
  box-shadow: 0 6px 58px 0 rgba(196, 203, 214, 0.10);
}

.search-button {
  height: 40px;
  border-radius: 4px;
}

.applications-list {
  /* display: flex;
  flex-wrap: wrap; */

}

.application-card {
  width: 100%;
  max-width: 600px;
  overflow: hidden;
    gap: 24px;
  width: 376px;
  height: 144px;
  flex-shrink: 0;
  border-radius: 4px;
  background-color: #FFF;
  margin: 12px 10px;
  /* cursor: pointer; */
}

.application-info {
  display: flex;
  gap: 16px;
  padding: 24px 16px 0px 24px;
}

.application-avatar {
  background-color: #fff;
  width: 45.91px;
  height: 42.313px;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.application-details {
  flex: 1 1;
}
.editIcon{
  cursor: pointer;
  font-size: 16px;
}
.application-name {
  color: var(--Black-60, #000);
  font-family: 'SegoeUI-SemiBold';
  font-size: 18px;
  font-style: normal;
  line-height: 38px;
  margin-top: -10px;
  line-height: 48px;
  /* 266.667% */
}
.card-title-container{
display: flex;
justify-content: space-between;
}
 
.application-description {
  color: var(--N2-Grey, #696969);
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
}

.application-meta {
  font-size: 12px;
  color: #696969;
  margin-top: 13px;
}

.meta-item {
  color: var(--N2-Grey, #696969);
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.meta-value {
  color: var(--Black-60, #000);
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.app-list {
 display: flex;
 flex-wrap:wrap;
 margin-left: -10px;
}

.add-app img {
  color: #6c5ce7;
  display: flex;
  width: 376px;
  height: 144px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  stroke-dasharray: 10 6;
  margin-right: 10px;
  margin-top: 12px;
  margin-left: 10px;
  cursor: pointer;
}

.app-description {
  width: 447px;
  height: 44px;
}

.modal-section {
  border-radius: 4px;
  margin-top: -16px;
}

.modal-section input {
  /* border-radius: 0px !important; */
  height: 34px;
}

.environmentConfig-section .ant-form-item-additional{
margin-top: -20px !important;
}

.param-key {
  width: 208px;
  height: 34px;
}

.param-value {
  width: 656px;
  height: 34px;
}
.param-value-des{
  margin-left: 16px;
  width: 639px;
  height: 34px;
}

.section-title {
width: 100%;
  height: 40px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--DX-T2, #E0F6F8);
  color: var(--black, #000);
  font-family: "Segoe UI";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  line-height: 40px;
  padding-left: 12px;
  margin-top: 25px;
}

.form-row-app {
  margin-bottom: 13px;
  margin-top: 16px;
  display: flex;
  width: 100%;
}

.css-dev-only-do-not-override-1v28nim.ant-space-compact {
  margin-bottom: -15px;
}

.form-item-half {
  flex: 1 1;
}

.icon-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-preview {
  position: absolute;
  right: 8px;
  background-color: #e8e8e8;
}

.section-title-icon {
  color: var(--Black-60, #000);
  font-family: "Segoe UI";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin-top: 15px;
}

.section-title-icon img {
  margin-bottom: -2px;
  margin-right: 5px;
}

.knowledge-base-section {
  margin-bottom: 20px;
}

.knowledge-base-title {
  font-size: 14px;
  font-weight: 500;
  color: #696969;
  margin-bottom: 12px;
}

.parameters-container {
  margin-top: 16px;
}

.param-con-text {
  display: flex;
  width: 100%;
}

.param-error-text {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  margin-left: 12px;
  width: 100%;
}

.remove-param {
  height: 20px;
  width: 20px;
  background-color: #E1E7F2;
  border-radius: 50%;
  margin: 30px 0px 0px 13px;
  text-align: center;
  line-height: 20px;

}

.add-paramater {
  color: var(--DX-Purple, #5F09E0);
  font-family: 'SegoeUI-SemiBold', sans-serif;
  font-size: 16px;
  margin-bottom: 31px;
  margin-top: 12px;
  cursor: pointer;
  display: flex;
  width: 168px;
  height: 24px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
}

.parameters-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.parameter-item {
  position: relative;
  display: flex;
  align-items: center;
}

.remove-btn-small {
  position: absolute;
  right: -24px;
  color: #ff4d4f;
  font-size: 16px;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-param-btn {
  color: #6c5ce7;
  font-size: 14px;
  padding: 0;
  margin-top: 8px;
}

.modal-footer {
  display: flex;
  justify-content: center;
  height: 60px;
}

.cancelbtn {
  width: 96px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 18px;
  margin-right: 40px;
}
.addbtn {
  width: 96px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 18px;
  margin-left: 40px;
}

/* Loading state styles */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-gif {
  width: 50px;
  height: 50px;
  margin-bottom: 16px;
}

.loading-text {
  color: #666;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

/* Empty state styles */
.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  color: #999;
}

.parameters-container {
  width: 100%;
}

.ant-form-item-control-input {
  min-height: auto !important;
}

.form-item-app-des .ant-form-item .ant-form-item-explain-error {
  color: #ff4d4f;
  margin-left: 12px !important;
}
.application-management-modal .ant-form-item .ant-form-item-explain-error {
  margin-top: 5px !important;
}
.application-management-modal .modal-section .param-value{
  border-bottom-left-radius: 0px !important;
  border-top-left-radius: 0px !important;
}
.application-management-modal .modal-section .param-key{
  border-bottom-right-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
.application-management-modal .environmentConfig-section .ant-form-item .ant-form-item-explain-error{
  margin-top: 23px !important;
}

.param-key-name{
  width: 208px;
  height: 34px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/application-management/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;oBACkB;;AAEpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;IACd,SAAS;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,SAAO;AACT;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;AACA;AACA,aAAa;AACb,8BAA8B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,kBAAkB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;AACA,4BAA4B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;AACA,WAAW;EACT,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":[".application-management-container {\n  padding: 12px 16px;\n  background-color: #f5f5f5;\n  font-family: 'Segoe UI', sans-serif;\n}\n\n.application-management-modal .ant-modal-body{\n  margin: 0px !important;\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h1 {\n  color: var(--Black-60, #000);\n  font-family: \"Henkel GT Flexa\";\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 40px;\n  /* 171.429% */\n}\n\n.search-container {\n  display: flex;\n  gap: 12px;\n}\n\n.search-input {\n  width: 200px;\n  border-radius: 8px;\n  border: 1px solid var(--Gry_707070, #707070);\n  background: #FFF;\n  box-shadow: 0 6px 58px 0 rgba(196, 203, 214, 0.10);\n}\n\n.search-button {\n  height: 40px;\n  border-radius: 4px;\n}\n\n.applications-list {\n  /* display: flex;\n  flex-wrap: wrap; */\n\n}\n\n.application-card {\n  width: 100%;\n  max-width: 600px;\n  overflow: hidden;\n    gap: 24px;\n  width: 376px;\n  height: 144px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  background-color: #FFF;\n  margin: 12px 10px;\n  /* cursor: pointer; */\n}\n\n.application-info {\n  display: flex;\n  gap: 16px;\n  padding: 24px 16px 0px 24px;\n}\n\n.application-avatar {\n  background-color: #fff;\n  width: 45.91px;\n  height: 42.313px;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.application-details {\n  flex: 1;\n}\n.editIcon{\n  cursor: pointer;\n  font-size: 16px;\n}\n.application-name {\n  color: var(--Black-60, #000);\n  font-family: 'SegoeUI-SemiBold';\n  font-size: 18px;\n  font-style: normal;\n  line-height: 38px;\n  margin-top: -10px;\n  line-height: 48px;\n  /* 266.667% */\n}\n.card-title-container{\ndisplay: flex;\njustify-content: space-between;\n}\n \n.application-description {\n  color: var(--N2-Grey, #696969);\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.application-meta {\n  font-size: 12px;\n  color: #696969;\n  margin-top: 13px;\n}\n\n.meta-item {\n  color: var(--N2-Grey, #696969);\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.meta-value {\n  color: var(--Black-60, #000);\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.app-list {\n display: flex;\n flex-wrap:wrap;\n margin-left: -10px;\n}\n\n.add-app img {\n  color: #6c5ce7;\n  display: flex;\n  width: 376px;\n  height: 144px;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  stroke-dasharray: 10 6;\n  margin-right: 10px;\n  margin-top: 12px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.app-description {\n  width: 447px;\n  height: 44px;\n}\n\n.modal-section {\n  border-radius: 4px;\n  margin-top: -16px;\n}\n\n.modal-section input {\n  /* border-radius: 0px !important; */\n  height: 34px;\n}\n\n.environmentConfig-section .ant-form-item-additional{\nmargin-top: -20px !important;\n}\n\n.param-key {\n  width: 208px;\n  height: 34px;\n}\n\n.param-value {\n  width: 656px;\n  height: 34px;\n}\n.param-value-des{\n  margin-left: 16px;\n  width: 639px;\n  height: 34px;\n}\n\n.section-title {\nwidth: 100%;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  background: var(--DX-T2, #E0F6F8);\n  color: var(--black, #000);\n  font-family: \"Segoe UI\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  line-height: 40px;\n  padding-left: 12px;\n  margin-top: 25px;\n}\n\n.form-row-app {\n  margin-bottom: 13px;\n  margin-top: 16px;\n  display: flex;\n  width: 100%;\n}\n\n.css-dev-only-do-not-override-1v28nim.ant-space-compact {\n  margin-bottom: -15px;\n}\n\n.form-item-half {\n  flex: 1;\n}\n\n.icon-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.icon-preview {\n  position: absolute;\n  right: 8px;\n  background-color: #e8e8e8;\n}\n\n.section-title-icon {\n  color: var(--Black-60, #000);\n  font-family: \"Segoe UI\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  margin-top: 15px;\n}\n\n.section-title-icon img {\n  margin-bottom: -2px;\n  margin-right: 5px;\n}\n\n.knowledge-base-section {\n  margin-bottom: 20px;\n}\n\n.knowledge-base-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #696969;\n  margin-bottom: 12px;\n}\n\n.parameters-container {\n  margin-top: 16px;\n}\n\n.param-con-text {\n  display: flex;\n  width: 100%;\n}\n\n.param-error-text {\n  color: #ff4d4f;\n  font-size: 12px;\n  margin-top: 4px;\n  margin-left: 12px;\n  width: 100%;\n}\n\n.remove-param {\n  height: 20px;\n  width: 20px;\n  background-color: #E1E7F2;\n  border-radius: 50%;\n  margin: 30px 0px 0px 13px;\n  text-align: center;\n  line-height: 20px;\n\n}\n\n.add-paramater {\n  color: var(--DX-Purple, #5F09E0);\n  font-family: 'SegoeUI-SemiBold', sans-serif;\n  font-size: 16px;\n  margin-bottom: 31px;\n  margin-top: 12px;\n  cursor: pointer;\n  display: flex;\n  width: 168px;\n  height: 24px;\n  flex-direction: column;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.parameters-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.parameter-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.remove-btn-small {\n  position: absolute;\n  right: -24px;\n  color: #ff4d4f;\n  font-size: 16px;\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.add-param-btn {\n  color: #6c5ce7;\n  font-size: 14px;\n  padding: 0;\n  margin-top: 8px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: center;\n  height: 60px;\n}\n\n.cancelbtn {\n  width: 96px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 18px;\n  margin-right: 40px;\n}\n.addbtn {\n  width: 96px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 18px;\n  margin-left: 40px;\n}\n\n/* Loading state styles */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n}\n\n.loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-gif {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 16px;\n}\n\n.loading-text {\n  color: #666;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* Empty state styles */\n.empty-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n  color: #999;\n}\n\n.parameters-container {\n  width: 100%;\n}\n\n.ant-form-item-control-input {\n  min-height: auto !important;\n}\n\n.form-item-app-des .ant-form-item .ant-form-item-explain-error {\n  color: #ff4d4f;\n  margin-left: 12px !important;\n}\n.application-management-modal .ant-form-item .ant-form-item-explain-error {\n  margin-top: 5px !important;\n}\n.application-management-modal .modal-section .param-value{\n  border-bottom-left-radius: 0px !important;\n  border-top-left-radius: 0px !important;\n}\n.application-management-modal .modal-section .param-key{\n  border-bottom-right-radius: 0px !important;\n  border-top-right-radius: 0px !important;\n}\n.application-management-modal .environmentConfig-section .ant-form-item .ant-form-item-explain-error{\n  margin-top: 23px !important;\n}\n\n.param-key-name{\n  width: 208px;\n  height: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
